"use strict";
/**
 * Created by wangtong on 2021/1/5
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = void 0;
var tslib_1 = require("tslib");
var axios_1 = tslib_1.__importDefault(require("axios"));
var json_bigint_1 = tslib_1.__importDefault(require("json-bigint"));
require("reflect-metadata");
var qs_1 = tslib_1.__importDefault(require("qs"));
var convert_1 = require("./convert");
var FormData = require('form-data');
var Api;
(function (Api) {
    function isRequestConfig(config) {
        // @ts-ignore
        return config['onUploadProgress'] !== undefined || config["onDownloadProgress"] !== undefined;
    }
    var DEFAULT_TIMEOUT = 300000; // 默认超时时长5min
    var DEFAULT_HEADER = "application/json";
    var ControllerMeta = {
        Base: Symbol("base"),
        Timeout: Symbol("timeout"),
    };
    var MethodMeta = {
        Action: Symbol("action"),
        Url: Symbol("url"),
        Header: Symbol("header"),
        Timeout: Symbol("timeout"),
    };
    function Controller(base, config) {
        return function (target) {
            Reflect.defineMetadata(ControllerMeta.Base, base, target);
            if (config) {
                Reflect.defineMetadata(ControllerMeta.Timeout, config.timeout, target);
            }
        };
    }
    Api.Controller = Controller;
    function Get(url, config) {
        return function (target, propertyKey, descriptor) {
            Reflect.defineMetadata(MethodMeta.Url, url, target, propertyKey);
            Reflect.defineMetadata(MethodMeta.Action, "get", target, propertyKey);
            if (config) {
                Reflect.defineMetadata(MethodMeta.Timeout, config.timeout, target, propertyKey);
            }
            // 封装执行函数
            var method = descriptor.value;
            // @ts-ignore
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                // 修改当前正在执行的方法
                // @ts-ignore
                this.__propertyKey = propertyKey;
                // @ts-ignore
                return method === null || method === void 0 ? void 0 : method.apply(this, args);
            };
            return descriptor;
        };
    }
    Api.Get = Get;
    function Post(url, config) {
        return function (target, propertyKey, descriptor) {
            Reflect.defineMetadata(MethodMeta.Url, url, target, propertyKey);
            Reflect.defineMetadata(MethodMeta.Action, "post", target, propertyKey);
            if (config) {
                Reflect.defineMetadata(MethodMeta.Header, config.header, target, propertyKey);
                Reflect.defineMetadata(MethodMeta.Timeout, config.timeout, target, propertyKey);
            }
            // 封装执行函数
            var method = descriptor.value;
            // @ts-ignore
            descriptor.value = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return tslib_1.__awaiter(this, void 0, void 0, function () {
                    var origin, response;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                origin = this.__propertyKey // 缓存一开始的值
                                ;
                                // @ts-ignore
                                this.__propertyKey = propertyKey;
                                return [4 /*yield*/, (method === null || method === void 0 ? void 0 : method.apply(this, args))];
                            case 1:
                                response = _a.sent();
                                // @ts-ignore
                                this.__propertyKey = origin; // 恢复一开始的值
                                return [2 /*return*/, response];
                        }
                    });
                });
            };
            return descriptor;
        };
    }
    Api.Post = Post;
    // 将检索值根据header进行转换
    function parsePostData(query, header) {
        switch (header) {
            case "application/json":
                return query;
            case "application/x-www-form-urlencoded":
                return qs_1.default.stringify(query);
            case "multipart/form-data":
                var formData = new FormData();
                for (var key in query) {
                    if (query.hasOwnProperty(key)) {
                        var value = query[key];
                        if (Array.isArray(value)) {
                            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                                var item = value_1[_i];
                                if (typeof item === "object") {
                                    formData.append(key, item);
                                }
                                else {
                                    formData.append(key, convert_1.Convert.parseString(item));
                                }
                            }
                        }
                        else {
                            if (typeof value === "object") {
                                formData.append(key, value);
                            }
                            else {
                                formData.append(key, convert_1.Convert.parseString(value));
                            }
                        }
                    }
                }
                return formData;
        }
    }
    var Service = /** @class */ (function () {
        function Service() {
            this.base = Reflect.getMetadata(ControllerMeta.Base, this.constructor) || "/";
            this.timeout = Reflect.getMetadata(ControllerMeta.Timeout, this.constructor) || DEFAULT_TIMEOUT;
            // 当前正在执行的方法
            this.__propertyKey = "";
        }
        // 将检索值根据header进行转换
        Service.prototype.parsePostData = function (query, header) {
            return parsePostData(query, header);
        };
        Service.prototype.beforeRequest = function (config) {
            return config;
        };
        Service.prototype.beforeRequestError = function (error) {
            // console.error(error)
            return error;
        };
        Service.prototype.afterResponse = function (response) {
            return response;
        };
        Service.prototype.afterResponseError = function (error) {
            // console.error(error)
            return error;
        };
        Service.prototype.fullRequest = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var url, param, config, action, header, timeout, response, instance, data;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '';
                            param = {};
                            config = {};
                            switch (args.length) {
                                case 1:
                                    if (typeof args[0] === "string") {
                                        url = args[0] || '';
                                    }
                                    else {
                                        param = args[0] || {};
                                    }
                                    break;
                                case 2:
                                    if (typeof args[0] === "string") {
                                        url = args[0] || '';
                                        param = args[1] || {};
                                    }
                                    else {
                                        param = args[0] || {};
                                        config = args[1] || {};
                                    }
                                    break;
                                case 3:
                                    url = args[0] || '';
                                    param = args[1] || {};
                                    config = args[2] || {};
                                    break;
                            }
                            if (!url) {
                                url = Reflect.getMetadata(MethodMeta.Url, this, this.__propertyKey);
                            }
                            action = Reflect.getMetadata(MethodMeta.Action, this, this.__propertyKey) || 'get';
                            header = Reflect.getMetadata(MethodMeta.Header, this, this.__propertyKey) || DEFAULT_HEADER;
                            timeout = Reflect.getMetadata(MethodMeta.Timeout, this, this.__propertyKey) || this.timeout || DEFAULT_TIMEOUT;
                            param = param || {};
                            if (!url) {
                                throw new Error("url不能为空");
                            }
                            instance = axios_1.default.create({
                                baseURL: this.base,
                                timeout: timeout,
                                withCredentials: true,
                                headers: {
                                    'Content-Type': header + ""
                                },
                                transformResponse: function (data) {
                                    return json_bigint_1.default({ storeAsString: true }).parse(data);
                                },
                                onUploadProgress: config === null || config === void 0 ? void 0 : config.onUploadProgress,
                                onDownloadProgress: config === null || config === void 0 ? void 0 : config.onDownloadProgress
                            });
                            instance.interceptors.request.use(this.beforeRequest, this.beforeRequestError);
                            instance.interceptors.response.use(this.afterResponse, this.afterResponseError);
                            if (!(action === "get")) return [3 /*break*/, 2];
                            return [4 /*yield*/, instance.get(url, {
                                    params: param,
                                })];
                        case 1:
                            // GET
                            response = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            data = this.parsePostData(param, header);
                            return [4 /*yield*/, instance.post(url, data, {
                                    headers: {
                                        'Content-Type': header + ""
                                    },
                                })];
                        case 3:
                            response = _a.sent();
                            _a.label = 4;
                        case 4: return [2 /*return*/, response];
                    }
                });
            });
        };
        Service.prototype.request = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var response;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.fullRequest.apply(this, args)];
                        case 1:
                            response = _b.sent();
                            return [2 /*return*/, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data];
                    }
                });
            });
        };
        Service = tslib_1.__decorate([
            Controller("/")
        ], Service);
        return Service;
    }());
    Api.Service = Service;
})(Api || (Api = {}));
exports.Api = Api;
exports.default = Api;
//# sourceMappingURL=api.js.map